import React, {Fragment} from "react";
import {Col, Input, Row} from "reactstrap";
import {BrowserView, MobileView} from "react-device-detect";
import 'ladda/dist/ladda-themeless.min.css';
import ToastHelper from "utils/ToastHelper";
import ImageViewComponent from "./ImageViewComponent";
import SFXButtonComponent from "components/SFXButtonComponent";
import S3DocumentUploadService from "../services/S3DocumentUploadService";
import FileUtil from "../domain/Util/FileUtil";

export default class AutoUploadDocumentUploadComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fileName: "",
            fileUpload: null,
            fileSize: 0,
            cameraOn: true,
            expSlideLeft: false,
            filePreview: null,
            showFilePreviewText: true,
            showFilePreview: true,
            maxSize: this.props.maxSize === undefined ? 5242880 : this.props.maxSize,
            hideButton: this.props.showButton === false,
            fileUploading: false
        };
        this.handleUpload = this.handleUpload.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    reset() {
        this.setState({
            fileName: "",
            fileUpload: null,
            fileSize: 0,
            cameraOn: true,
            expSlideLeft: false,
            filePreview: null,
            showFilePreviewText: true,
            showFilePreview: true,
        })
    }

    handleChange = event => {
        if (event.target.files[0].size > this.state.maxSize) {
            this.setState({
                fileName: "",
                fileUpload: null,
                fileSize: 0,
                filePreview: null,
                showFilePreviewText: false,
            });
            ToastHelper.error("Only files less than " + FileUtil.getSizeInMB(this.state.maxSize) + " MB allowed.")
            if (this.props.onFileSelected !== undefined)
                this.props.onFileSelected(null);
        } else {
            this.setState({
                fileName: event.target.value,
                fileUpload: event.target.files[0],
                fileSize: event.target.files[0].size,
                filePreview: URL.createObjectURL(event.target.files[0]),
                showFilePreviewText: false,
            }, this.uploadFile.bind(this));
            if (this.props.onFileSelected !== undefined) {
                this.props.onFileSelected(
                    {
                        fileName: event.target.value,
                        fileUpload: event.target.files[0],
                        fileSize: event.target.files[0].size,
                        filePreview: URL.createObjectURL(event.target.files[0]),
                        showFilePreviewText: false,
                    }
                );
            }
        }
    };

    //Get presigned URL to allow image to be uploaded straight to S3
    handleUpload(event) {
        event.preventDefault();

        this.uploadFile();
    }

    uploadFile() {
        this.setState({fileUploading: true})
        let fileType = FileUtil.getExtensionOfFile(this.state.fileUpload.name);
        let mimeType = FileUtil.getMimeType(fileType);

        let self = this;

        S3DocumentUploadService.getPresignedUrl({
            "file-type": fileType,
            "document-type": this.props.documentType
        }).then(response => {

            if (response.presignedUrl === undefined) {
                ToastHelper.error("Failed to retrieve upload url.");
                self.setState({
                    fileUploading: false
                });
                return;
            }

            const xhr = new XMLHttpRequest();
            xhr.open('PUT', response.presignedUrl);
            xhr.onreadystatechange = function () {

                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        self.setState({
                            expSlideLeft: false,
                            filePreview: null,
                            showFilePreviewText: true,
                            showFilePreview: true,
                            hideButton: true,
                            fileUploading: false,
                            fileUploaded: true
                        });
                        if (self.props.onUploadSuccessful !== undefined)
                            self.props.onUploadSuccessful(response);
                    } else {
                        ToastHelper.error("Error while uploading image.");
                        self.setState({
                            fileUploading: false
                        });
                    }
                }
            };
            xhr.overrideMimeType(mimeType);
            xhr.setRequestHeader('Content-Type', mimeType);
            xhr.send(this.state.fileUpload);
        });
    }

    toggle(name) {
        this.setState({
            [name]: !this.state[name],
            progress: 0.5
        })
    }

    //FOR MOBILE to change file input to the phones camera
    showHideCameraOption() {
        this.setState({
            fileSize: 0,
            fileUpload: null,
            fileName: "",
            filePreview: null,
            showFilePreviewText: true,
            cameraOn: !this.state.cameraOn
        });
    }

    isFileValid() {
        if (this.state.fileSize <= 0 || this.state.fileSize > this.state.maxSize)
            return false;

        return true;
    }

    getFileName() {
        return this.props.fileName || this.state.fileName;
    }

    render() {

        if (this.props.documentType === undefined) {
            return <Fragment>No document type specified.</Fragment>;
        }

        let uploadOrCamera = "";
        let changeUploadButton = "";
        let space = "";

        if (this.state.cameraOn) {
            uploadOrCamera = <Input type="file" id="file-input" name="file-input" value={this.getFileName()}
                                    onChange={this.handleChange.bind(this)} accept="image/*, .pdf"/>;
        } else {
            space = <br/>;
            uploadOrCamera = <input type="file" id="file-input2" name="file-input2" value={this.getFileName()}
                                    onChange={this.handleChange.bind(this)} accept="image/*" capture/>;
        }

        return <Fragment>
            <BrowserView>
                <Row>
                    <Col>
                        <Input type="file" id="file-input" name="file-input" value={this.getFileName()}
                               onChange={this.handleChange.bind(this)} accept="image/*, .pdf"/>
                    </Col>
                    <Col>
                        {this.state.fileUploaded &&
                            <span style={{color: "green", fontSize: "10pt"}}><i className={"fa fa-check"}/></span>}
                        {this.state.fileUploading &&
                            <span style={{color: "green", fontSize: "10pt"}}><i className={"fa fa-hourglass"}/></span>}
                    </Col>
                </Row>

            </BrowserView>

            <MobileView>


                <Row>
                    <Col>
                        {uploadOrCamera}
                        {space}
                        {changeUploadButton}
                    </Col>

                    <Col>
                        {this.state.fileUploaded &&
                            <span style={{color: "green", fontSize: "10pt"}}><i className={"fa fa-check"}/></span>}
                        {this.state.fileUploading &&
                            <span style={{color: "green", fontSize: "10pt"}}><i className={"fa fa-hourglass"}/></span>}
                    </Col>
                </Row>

            </MobileView>
        </Fragment>
    }

    static renderImageWithCloseButton(file, clickEvent) {
        if (file === undefined)
            return <Fragment>No file specified</Fragment>;
        let src = file.filePreview || file.presignedUrl || file.preSignedUrl;

        return <div style={{
            width: "200px",
            height: "150px",
            margin: "0 auto",
            position: "relative"
        }}>
            <ImageViewComponent
                src={src}
                fileName={file.fileName}
                style={{
                    maxWidth: "200px",
                    maxHeight: "150px",
                    margin: "0px auto",
                    display: "block"
                }}
                alt={""}
            />
            <SFXButtonComponent
                style={{
                    position: "absolute",
                    top: "0px",
                    right: "-40px"
                }}
                color="danger"
                onClick={clickEvent}>
                <i className="fa fa-times"/>
            </SFXButtonComponent>
        </div>
    }

    static renderImageWithoutCloseButton(file) {
        if (file === undefined)
            return <Fragment>No file specified</Fragment>;
        let src = file.filePreview || file.presignedUrl || file.preSignedUrl;

        return <div style={{
            width: "200px",
            height: "150px",
            margin: "0 auto",
            position: "relative"
        }}>
            <ImageViewComponent
                src={src}
                fileName={file.fileName}
                style={{
                    maxWidth: "200px",
                    maxHeight: "150px",
                    margin: "0px auto",
                    display: "block"
                }}
                alt={""}
            />
        </div>
    }

    static renderImageDisplay(file) {

        if (file === undefined)
            return <Fragment>No file specified</Fragment>;

        let src = file.filePreview || file.presignedUrl || file.preSignedUrl;

        return <div className={"pull-left"} style={{display: "block"}}>
            <BrowserView>
                <ImageViewComponent
                    src={src}
                    fileName={file.fileName}
                    style={{
                        maxHeight: '200px',
                        maxWidth: '300px',
                        width: "100%"
                    }}
                    alt={""}
                />

            </BrowserView>
            <MobileView>
                <ImageViewComponent
                    src={src}
                    fileName={file.fileName}
                    style={{
                        maxHeight: '30vh',
                        maxWidth: '40vw',
                        width: "100%"
                    }}
                    alt={""}
                />

            </MobileView>
        </div>
    }
}
